export enum BRAND_LOGO_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  BLACK = 'black',
}

export enum BRAND_LOGO_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
